/*********************** Custom JS for Boost AI Search & Discovery  ************************/

  document.addEventListener('DOMContentLoaded', function () {
    function hideBoostTitleIfImage() {
      document
        .querySelectorAll('#boost-sd__collection-header .boost-sd__collection-header')
        .forEach(function (wrapper) {
          const img = wrapper.querySelector('.boost-sd__header-image-inner');

          if (img && img.src && img.src.trim() !== '') {
            const title = wrapper.querySelector('.boost-sd__header-title');
            if (title) {
              title.style.display = 'none';
            }
          }
        });
    }

    // Run once on load
    hideBoostTitleIfImage();

    // In case Boost re-renders dynamically
    const target = document.getElementById('boost-sd__collection-header') || document.body;
    const observer = new MutationObserver(hideBoostTitleIfImage);
    observer.observe(target, { childList: true, subtree: true });
  });

